import React, { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./actions/firebase";
import NorthwellSamlLogin from "./viewpages/NorthwellSamlLogin";
import DemoLoginLog from "./viewpages/DemoLoginLog";
import { store } from "./redux/store";
import * as dasboardActions from "../src/redux/actions/dashboard.action";
import { ToastContainer } from "react-toastify";
import PasswordResetPage from "./viewpages/PasswordResetPage";
import AddDetailsPage from "./viewpages/AddDetailsPage";
import FreshChatComp from "./freshChat";
import OnBoarding from "./viewpages/newpages/onBoarding/providerOnboarding";
import Socket from "./helper/Websocket";
import { connect } from "react-redux";
import WithApolloClient from "./wrapper/apolloWrapper";
import "react-toastify/dist/ReactToastify.css";
import { GlobalLoader } from "./shared/components/globalLoader/globalLoader";
import contentReaderMarkdown from "./modules/contentReaderMarkdown/contentReaderMarkdown";
import providerEmailVerification from "./modules/providerEmailVerification/providerEmailVerification";
import SignUpCont from "./modules/newProviderApp/container/SignUpCont";
import { isNewApp } from "./helper/CommonFuncs";
import EpicCont from "./modules/epic/container/EpicCont";
import FhirClientProvider from "./modules/fhir/FhirClientProvider";
import FhirClientStandAloneComponent from "./modules/fhir/fhirStandAloneComponent";
import TemplateNDicationCont from "./modules/notes-fhir/container/TemplateNDicationCont";
import NotesLastStep from "./modules/epic/components/notesLastStep";
import ContentReaderLink from "./modules/contentReaderLink/contentReaderLink";
import { ShowAlert } from "./common/alert";
import RequestATemplate from "./modules/requestATemplate/requestATemplate";
import StripePaymentCont from "./modules/payment-gateway/containers/StripePaymentCont";
import StripePaymentStatusCont from "./modules/payment-gateway/containers/StripePaymentStatusCont";
import StripePaymentGatewayCont from "./modules/payment-gateway/containers/StripePaymentGatewayCont";
import ContactSales from "./modules/contactSales/contactSales";
// import { usePushNotifications } from "./modules/push-notification/component/pushNotification";
// import SocialSignUpSignInCont from "./modules/newProviderApp/container/SocialSignUpSignInCont";
import GoogleTagManager from "./modules/googleTagManager/googleTagManager";
import DatadogRum from "./modules/Analytics/datadogRum";
import PendoLoader from "./modules/Analytics/pendoLoader";
// import { initializePendo } from "./actions";
import GetPlayback from "./modules/getPlayback/getPlayback";
import useReloadOnBackOrForward from "./wrapper/useBrowserReload";
import IframeTopBreakout from "./wrapper/IframeTopBreakout";
import { isAllowedForRegion } from "./actions/utils";
import GoogleAuthCallback from "./auth/googleAuthCallback";
const HomeCont = React.lazy(() => import("./viewpages/newpages/home/homeCont"));
const AutoEnroll = React.lazy(() => import("./modules/newProviderApp/container/AutoEnroll"));
// const VideoChat = React.lazy(() => import("./components/newcomponents/VideoCallView/VideoChat"));
const onboardContainer = React.lazy(() => import("./viewpages/newpages/providerOnboard/container/onboardContainer"));
const LoginScreenCont = React.lazy(() => import("./modules/newProviderApp/container/LoginCont"));
const SocialSignUpSignInCont = React.lazy(() => import("./modules/newProviderApp/container/SocialSignUpSignInCont"));
const NewSignUpPage = React.lazy(() => import("./modules/newProviderApp/container/newSignupPage"));
const TrialUsersCont = React.lazy(() => import("./modules/trialUsers/container/trialUsersCont"));
const VimContainer = React.lazy(() => import("./modules/Vim-integration/container/VimContainer"));
const DemoWrapper = React.lazy(() => import("./modules/Vim-integration/container/Demo/DemoWrapper"));

const LoggedInUser = React.lazy(() => import("./modules/newProviderApp/container/loggedInUsers"));

const AuthLoginPage = isNewApp ? NewSignUpPage : NorthwellSamlLogin;

var Root = (props) => {
   useReloadOnBackOrForward();
   const { userCredentials, loader } = props;
   // usePushNotifications();

   useEffect(() => {
      const showDisabledUserMessage = localStorage.getItem("disabledUserMessage");
      if (showDisabledUserMessage === "true") {
         ShowAlert("Your session has expired. Please log in to continue.", "error");
         localStorage.removeItem("disabledUserMessage");
      }
      if (isAllowedForRegion) {
         window.socket = new Socket();
      }
   }, []);

   if (window.fcWidget) {
      window.fcWidget.destroy();
      window.fcWidget.user.clear();
   }
   if (window.fcWidget && userCredentials?.user) {
      window.fcWidget.user.update({
         firstName: userCredentials?.user?.name,
         externalId: userCredentials?.user?.userId,
         restoreId: userCredentials?.user?.userId,
      });
   }
   return (
      <>
         {loader && <GlobalLoader />}
         <ToastContainer />
         <DatadogRum />
         {isAllowedForRegion && <PendoLoader />}
         {isAllowedForRegion && userCredentials?.user && <FreshChatComp userCredentials={userCredentials} />}
         {isAllowedForRegion && window.location.pathname === "/login" &&
            window.location.pathname === "/trial" &&
            !localStorage.getItem("providerEmail") && <FreshChatComp />}
         <Router>
            <IframeTopBreakout />
            {isAllowedForRegion && <GoogleTagManager />}
            <Suspense fallback={<div />}>
               <Switch>
                  <Route exact path="/reset-password" component={PasswordResetPage} />
                  {/* <Route exact path="/sign-up" component={onboardContainer} /> */}
                  <Route path="/onboarding" component={OnBoarding} />
                  <Route path="/welcome" component={AutoEnroll} />
                  <Route path="/check" component={LoggedInUser} />
                  <Route path="/trial" component={TrialUsersCont} />
                  <Route path="/vim_callback" component={VimContainer} />
                  <Route path="/link" component={ContentReaderLink} />
                  <Route path="/contact-sales" component={ContactSales} />
                  <Route path="/get" component={GetPlayback} />
                  <Route path="/demo" component={DemoWrapper} />
                  <Route path="/callback_standalone" name="standalone" component={FhirClientStandAloneComponent} />
                  <Route path="/close_callback" name="close-callback" component={NotesLastStep} />
                  <Route exact path="/auth/google/callback" component={GoogleAuthCallback} />
                  <Route exact path="/login" component={AuthLoginPage} />
                  <Route exact path="/login-log" component={DemoLoginLog} />
                  {/* <Route exact path="/video-call" component={VideoChat} /> */}
                  <Route exact path="/details" component={NorthwellSamlLogin} />

                  <Route exact path="/view_notes" component={contentReaderMarkdown} />
                  <Route exact path="/verify-provider" name="Home" component={providerEmailVerification} />
                  <Route
                     exact
                     path="/sign-up"
                     name="newApp"
                     component={AuthLoginPage}
                  />
                  <Route exact path="/callback" name="Fhir" component={FhirClientProvider} />
                  <Route exact path="/fhir" name="Fhir" component={EpicCont} />
                  <Route exact path="/payment" name="payment" component={StripePaymentCont} />
                  <Route exact path="/payment-gateway" name="payment-gateway" component={StripePaymentGatewayCont} />
                  <Route exact path="/payment-status" name="payment-status" component={StripePaymentStatusCont} />
                  <Route exact path="/request_template" name="RequestTemplate" component={RequestATemplate} />
                  <Route path="/" name="Home" component={HomeCont} />
               </Switch>
            </Suspense>
         </Router>
      </>
   );
};

const mapStateToProps = (state) => {
   return {
      userCredentials: state.auth.userCredentials,
      loader: state.global.loader,
   };
};

export default WithApolloClient(connect(mapStateToProps)(Root));
